module.exports = __webpack_public_path__ + "static/img/备案图标.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/备案图标.png
// module id = wCij
// module chunks = 1